import React, { useState } from "react";
import { toast } from "react-toastify";
import { Formik, Form, Field } from "formik";
import { FileUploader } from "react-drag-drop-files";
import { Modal } from "react-bootstrap";
import Title from "designs/v1/components/Title";
import Button from "designs/v1/components/Button";
import {
  validateIncomeProof,
  uploadReactivateProofApi,
} from "designs/v1/pages/ModifyKyc/services";
import { jsonToFormData } from "utils";
import { handleFileResizer } from "utils/imageResizer";

const PanProof = ({ activeUserDetail, isLoading, setIsLoading, setStep }) => {
  const [showPanModal, setShowPanModal] = useState({
    show: false,
    data: "",
  });
  const proofTypes = [{ name: "PAN", value: "PAN" }];
  const initialValues = {
    type: "PAN",
    file1: "",
    file_type: "Image",
  };

  const handleValidate = (values) => {
    const errors = {};
    if (!values.type) {
      errors.type = "Proof Type is Required";
    }
    if (!values.file1) {
      errors.type = "Proof is Required";
    }
    return errors;
  };

  const handleSubmit = async (value) => {
    setIsLoading(true);
    const formValue = {
      request_type: "Reactivation",
      doc_name: activeUserDetail?.request_number,
      ...value,
    };
    try {
      const resp = await uploadReactivateProofApi(jsonToFormData(formValue));
      const data = resp.data?.data;
      toast.success("PAN proof uploaded successfully.");
      setIsLoading(false);
      setStep("AddressProof")
      // setShowPanModal({ show: true, data });
    } catch (error) {
      const { data } = error.response || {};
      toast.error(data.message || "Internal server error!");
      setIsLoading(false);
    }
  };

  const handleFileUpload = async (name, file, setFieldValue) => {
    if (!file) {
      return setFieldValue(name, "");
    }
    const allowed_types = ["image/png", "image/jpeg", "application/pdf"];
    if (!allowed_types.includes(file.type)) {
      setFieldValue(name, "");
      return toast.error(
        "Only Images/Pdf are allowed ( JPG | PNG | PDF )",
        "Error"
      );
    }
    const fileSize = file.size / 1024 ** 2;
    if (fileSize >= 4) {
      setFieldValue(name, "");
      return toast.error("Error: Please upload a file smaller than 4 MB");
    }
    if (file.type === "application/pdf") {
      setFieldValue("file_type", "pdf");
      setIsLoading(true);
      try {
        const resp = await validateIncomeProof(jsonToFormData({ file }));
        const isEncrypted = resp.data?.message;
        if (isEncrypted) {
          setFieldValue(name, "");
          toast.error("Please upload a file without password protected.");
        } else {
          setFieldValue(name, file);
        }
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        setFieldValue(name, "");
        toast.error("Internal server error!");
      }
    } else {
      setFieldValue("file_type", "Image");
      const img = new Image();
      img.src = window.URL.createObjectURL(file);
      img.onload = async () => {
        if (img.width >= 400 && img.height >= 350) {
          const newFile = await handleFileResizer(file);
          setFieldValue(name, newFile);
        } else {
          setFieldValue(name, "");
          return toast.error(
            `The image you uploaded is of lower resolution. Please upload a higher resolution image.`
          );
        }
      };
    }
  };

  return (
    <React.Fragment>
      <Title title="Upload your PAN proof" />
      <div className="row">
        <div className="col-md-9">
          <div className="form-group">
            <div className="mb-2">
              <Formik
                initialValues={initialValues}
                validate={handleValidate}
                onSubmit={handleSubmit}
              >
                {({ values, isValid, dirty, isSubmitting, setFieldValue }) => (
                  <Form>
                    <div className="form-group my-2">
                      <label className="py-1">Proof Type</label>
                      <Field
                        as="select"
                        name="type"
                        className="form-select"
                        onChange={({ target }) => {
                          setFieldValue("type", target.value);
                          setFieldValue("file1", "");
                        }}
                      >
                        {proofTypes.map((option, index) => {
                          return (
                            <option
                              key={index}
                              value={option.value}
                            >
                              {option.name}
                            </option>
                          );
                        })}
                      </Field>
                    </div>
                    <div className="form-group my-2">
                      <div className="d-flex align-items-center justify-content-between">
                        <label className="py-1">Proof Image</label>
                        <div className="file_limit_text">
                          Maximum file size: 4 MB
                        </div>
                      </div>
                      <Field name="file1">
                        {(props) => (
                          <div className="file-uploader-container">
                            <FileUploader
                              {...props}
                              key={values.type}
                              label="Upload or drop a file here"
                              handleChange={(file) =>
                                handleFileUpload("file1", file, setFieldValue)
                              }
                              name="file"
                              types={["JPG", "JPEG", "PNG", "PDF"]}
                            />
                          </div>
                        )}
                      </Field>
                      {values?.file1 && (
                        <p>
                          <small>File name: {values.file1?.name}</small>
                        </p>
                      )}
                    </div>
                    <div className="d-flex my-4">
                      <div className="mx-1">
                        <Button
                          type="button"
                          title="Back"
                          handleClick={() => setStep("DematUccForm")}
                          disabled={isLoading}
                        />
                      </div>
                      <div className="mx-1">
                        <Button
                          title="Submit"
                          disabled={!isValid || !dirty}
                        />
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
      <Modal show={showPanModal.show}>
        <Modal.Header>
          <Modal.Title>Name as per PAN</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h6>
            Do you want to proceed with this{" "}
            <strong>{showPanModal.data?.full_name}</strong>
          </h6>
        </Modal.Body>
        <Modal.Footer>
          <Button
            title="Proceed"
            handleClick={() => setStep("AddressProof")}
          />
          <Button
            title="Cancel"
            handleClick={() => setShowPanModal({ show: false, data: null })}
          />
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default PanProof;
